import React from 'react'
import axios from 'axios'
import { render } from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthenticationContext, AuthenticationProvider, oidcLog, getUserManager } from '@axa-fr/react-oidc-context'
import oidcConfiguration from './config/config.oidc'
import Routes from './pages/routes'
import config from './config'

import 'antd/dist/antd.css'
import 'bootstrap/dist/css/bootstrap.css'
import './style.css'
import './custom.css'
import './animate.css'
import './index.css'
import './react-table.css'

const CustomAuthenticating = () => <div>Authenticating ...</div>

const App = () => {    
    const redirectLocaltixUserToInfoPage = oidcUser => {
        if (oidcUser != null && oidcUser.profile.oztix_brand.toLowerCase() === 'localtix') {
            window.location.replace(`${config.APPS_LOCALTIX_BASE_URL}/insights/`)
        }
    }

    const setAxiosDefaultHeaders = oidcUser => {
        axios.defaults.headers.common['Authorization'] =
            oidcUser == null ? null : `bearer ${oidcUser.access_token}`
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
        axios.defaults.headers.post['Content-Type'] = 'application/json'
    }

    const setUserManagerEvents = userManager => {
        userManager.events.addUserSignedOut(() => {
            userManager.signoutRedirect()
        })
    }           

    return (
        <div>            
            <AuthenticationProvider
                configuration={oidcConfiguration}
                loggerLevel={oidcLog.INFO}
                isEnabled={true}
                notAuthorized={CustomAuthenticating}
                notAuthenticated={CustomAuthenticating}
                authenticating={CustomAuthenticating}
                callbackComponentOverride={CustomAuthenticating}
            >
                <Router>
                    <AuthenticationContext.Consumer>
                        {props => {
                            redirectLocaltixUserToInfoPage(props.oidcUser)
                            setAxiosDefaultHeaders(props.oidcUser)
                            setUserManagerEvents(getUserManager())
                            return <Routes />
                        }}
                    </AuthenticationContext.Consumer>
                </Router>
            </AuthenticationProvider>
        </div>
    )
}

render(<App />, document.getElementById('root'))
